export const BREAKPOINTS = {
  mobile: 768, // md
  tablet: 1024, // lg
  desktop: 1280, // xl
  smallMobile: 400, // sm
  "2xl": 1460, // 2xl
};
